import { render, staticRenderFns } from "./CardIndicacaoPcd.vue?vue&type=template&id=3825242e&"
import script from "./CardIndicacaoPcd.vue?vue&type=script&lang=js&"
export * from "./CardIndicacaoPcd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports